import { render } from "./ActiveTotalProperty.vue?vue&type=template&id=69b97320&ts=true"
import script from "./ActiveTotalProperty.vue?vue&type=script&lang=ts"
export * from "./ActiveTotalProperty.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__